import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

export const body: Record<string, ThemeUIStyleObject> = {
    default: {
        lineHeight: '24px',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.normal,
    },
    'default-base': {
        variant: 'body.default',
        fontFamily: (theme: CarrotTheme) => theme.fonts.body,
    },
    'default-alt': {
        variant: 'body.default',
        fontFamily: (theme: CarrotTheme) => theme.fonts.publicoText,
    },
};
